import { Link } from "react-router-dom";
import styled from "styled-components";
import { FeatureContainer } from "./RoundedContainer";

const NoHoverLink = styled(Link)`
    &&:hover
    {
        opacity: 1;
    }
`;

const RoundedCard = (props: {
  title: string;
  description: string;
  icon: string;
  rightAlign?: boolean;
  highlightTransition?: boolean;
  linkTo?: string;
  disable?: boolean;
  tooltip?: string;
}) => {
  const {
    title,
    description,
    icon,
    rightAlign,
    highlightTransition,
    linkTo,
    disable,
    tooltip,
  } = props;

  const content = (
    <FeatureContainer
      $rightAlign={rightAlign}
      $highlightTransition={highlightTransition}
      style={
        disable
          ? {
              opacity: 0.5,
              filter: "grayscale(100%)",
              cursor: "not-allowed",
            }
          : undefined
      }
      title={disable ? tooltip || "Coming soon" : undefined}
    >
      <div>
        <h1>{title}</h1>
        <img src={icon} alt="" />
      </div>
      <p>{description}</p>
    </FeatureContainer>
  );

  if (disable) {
    return content;
  }

  return linkTo ? (
    <NoHoverLink style={{}} to={linkTo}>
      {content}
    </NoHoverLink>
  ) : (
    content
  );
};

export default RoundedCard;
